
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import LicensingSection from './components/LicensingSection';
import PublishingSection from './components/PublishingSection';

const LicensingPublishingPage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <main className="pt-24">
        <LicensingSection />
        <PublishingSection />
      </main>
      <Footer />
    </div>
  );
};

export default LicensingPublishingPage;
